import * as constant from "./constant";
import { constant as layoutConstant } from "store/Layout";
import { Get } from "utils/request";
import { API } from "utils/api";
import { fromJS } from "immutable";
import { Post } from "utils/request";
import { message } from "antd";
import { sum } from "utils/arr";
import {
  getGroup,
  groupIdOf,
  getOtherTables,
  isTableFilled,
  markPrompted,
  getPending,
  setPending,
  buildValueMap,
  applyValueMap
} from "utils/copyScore";

export const changeItem = (target, value) => ({
  type: constant.CHANGE_ITEM,
  target: target,
  value: value
});

export const changeScoreCard = (source) => ({
  type: constant.CHANGE_SCORE_CARD,
  source
});

export const currentUserIsScored = () => {
  return (dispatch) => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      Get(`${API.SCORER}/${userId}`).then((res) => {
        // 校验通过
        dispatch({
          type: constant.CHANGE_ITEM,
          target: ["modal", "isLogin"],
          value: true
        });
        dispatch({
          type: constant.CHANGE_ITEM,
          target: ["userInfo"],
          value: fromJS(res)
        });
      });
    }
  };
};

export const submitUserInfo = (values, signature) => {
  return (dispatch) => {
    let data = values;
    data.signature = signature;

    Post(API.SCORER, data).then((res) => {
      dispatch({
        type: constant.CHANGE_ITEM,
        target: ["userInfo"],
        value: fromJS(res)
      });

      localStorage.setItem("userId", res.id);
      dispatch({
        type: constant.CHANGE_ITEM,
        target: ["currentPage"],
        value: 1
      });
    });
  };
};

export const loadProject = (projectId) => {
  return (dispatch) => {
    Get(
      `${API.PROJECT_BASE}/${projectId}?t=1&u=${localStorage.getItem("userId")}`
    ).then((res) => {
      dispatch({
        type: constant.CHANGE_ITEM,
        target: ["projectInfo"],
        value: fromJS(res)
      });
    });
  };
};

export const loadScoreTable = (tableId, projectInfo) => {
  return (dispatch) => {
    dispatch({
      type: layoutConstant.CHANGE_ITEM,
      target: ["pageLoading"],
      value: true
    });

    Get(
      `${API.TABLE_BASE}/${tableId}?rounds=${projectInfo.get(
        "status"
      )}&u=${localStorage.getItem("userId")}`
    ).then((res) => {
      res = fromJS(res);

      // 关联评分表回填：若该表属于某分组、存在待复制数据、非源表、且该表尚未评分，
      // 则用源表数据回填显示（默认视图就是 A 复制过来的数据）。
      // 注意：
      // 1) 不能用 pending.appliedTables 判定——刷新后 appliedTables 已含本表，
      //    会导致不再回填。
      // 2) 回填只影响页面显示（currentTableInfo），打开表时不再调用 autoSave，
      //    因此不会把回填数据写进 localStorage 覆盖用户修改后的自动保存内容；
      //    用户修改后的数据由"是否加载自动保存内容"弹窗点确定恢复。
      const projectId = String(projectInfo.get("id"));
      const tid = String(tableId);
      const group = getGroup(projectId, tid);
      if (group) {
        const groupId = groupIdOf(group);
        const pending = getPending(projectId, groupId);
        if (pending && pending.sourceTableId !== tid) {
          const tables = projectInfo.get("tables");
          const tableItem =
            tables && tables.find((i) => String(i.get("id")) === tid);
          const isScored = !!(tableItem && tableItem.get("status"));
          if (!isScored) {
            res = applyValueMap(res, pending.valueMap);
          }
        }
      }

      dispatch({
        type: constant.CHANGE_ITEM,
        target: ["currentTableInfo"],
        value: res
      });

      // 打开新表时强制关闭"导航卡"侧边抽屉：
      // modal.scoreDrawer 一旦打开过就不会自动复位（返回列表/提交均不清除），
      // 不重置会导致下次打开评分表时抽屉残留弹出。
      dispatch({
        type: constant.CHANGE_ITEM,
        target: ["modal", "scoreDrawer"],
        value: false
      });

      dispatch({
        type: constant.CHANGE_ITEM,
        target: ["scoreCard"],
        value: fromJS({
          data: res.get("basic"),
          type: "basic"
        })
      });

      dispatch({
        type: constant.CHANGE_ITEM,
        target: ["currentPage"],
        value: 2
      });

      // 打开表时【不】调用 autoSave：
      // - 刚进入评分表（含回填 A 数据）不应触发"自动保存成功"，也不应把加载的数据
      //   写入 localStorage——否则会覆盖用户之前修改后保存的自动保存内容，
      //   导致"是否加载自动保存内容"点确定恢复不出修改后的数据。
      // - 自动保存只在用户实际操作时触发（切换层级 changeScoreCard 等）。
      dispatch({
        type: layoutConstant.CHANGE_ITEM,
        target: ["pageLoading"],
        value: false
      });
    });
  };
};

export const inputValueChange = (target, value) => ({
  type: constant.CHANGE_FACTOR_VALUE,
  target,
  value
});

/**
 * 校验当前评分表分数是否通过（基本层=100；派生层/因子层合计%100===0）
 */
const validateScore = (currentTableInfo) => {
  const basicValues = currentTableInfo
    .get("basic")
    .filter((i) => i.get("status", 1) !== 0)
    .map((i) => i.get("value", -1))
    .toArray();
  if (basicValues.indexOf(-1) !== -1 || parseInt(sum(basicValues)) !== 100) {
    return false;
  }

  const normalValues = currentTableInfo
    .get("normal")
    .filter((i) => i.get("status", 1) !== 0)
    .map((i) => i.get("value", -1))
    .toArray();
  if (
    normalValues.indexOf(-1) !== -1 ||
    parseInt(sum(normalValues)) % 100 !== 0
  ) {
    return false;
  }

  const subValues = currentTableInfo
    .get("sub")
    .filter((i) => i.get("status", 1) !== 0)
    .map((i) => i.get("value", -1))
    .toArray();
  if (subValues.indexOf(-1) !== -1 || parseInt(sum(subValues)) % 100 !== 0) {
    return false;
  }

  return true;
};

/**
 * "确定/提交"按钮点击：先校验，再判断是否需要弹出"复制评分数据"提示
 * - 校验不通过：直接提示错误，不提交也不弹窗
 * - 校验通过 且 需要复制提示：弹出提示（暂不提交，由用户后续点击 是/否 触发实际提交）
 * - 校验通过 且 不需要复制提示：直接提交
 */
export const trySubmit = (currentTableInfo, projectInfo) => {
  return (dispatch) => {
    if (!validateScore(currentTableInfo)) {
      message.error("分数校验不通过");
      return;
    }

    // 判断是否需要弹出"复制评分数据"提示
    const projectId = String(projectInfo.get("id"));
    const tableId = String(currentTableInfo.get("id"));
    const group = getGroup(projectId, tableId);
    if (group) {
      const otherTables = getOtherTables(projectInfo, group, tableId);
      const allUnfilled = otherTables.every(
        (t) => !isTableFilled(t.id, projectInfo)
      );
      if (allUnfilled) {
        dispatch({
          type: constant.SHOW_COPY_PROMPT,
          targetNames: otherTables.map((t) => t.title),
          targetIds: otherTables.map((t) => t.id)
        });
        return;
      }
    }

    // 不需要弹窗，直接提交
    dispatch(submitScore(currentTableInfo, projectInfo));
  };
};

export const submitScore = (currentTableInfo, projectInfo) => {
  return (dispatch) => {
    if (!validateScore(currentTableInfo)) {
      message.error("分数校验不通过");
      return;
    }

    let data = currentTableInfo.set("scorer", localStorage.getItem("userId"));
    Post(`${API.SCORE}?rounds=${projectInfo.get("status")}`, data).then(
      (res) => {
        message.success("提交成功！");
        // 确认提交后把本地缓存更新为"提交后的数据"（静默，不弹"自动保存成功"），
        // 避免下次打开该表时"是否加载自动保存内容"恢复提交前的旧数据。
        dispatch(autoSave(true));
        dispatch({
          type: constant.CHANGE_ITEM,
          target: ["currentPage"],
          value: 3
        });
      }
    );
  };
};

export const autoSave = (silent) => ({
  type: constant.AUTO_SAVE,
  silent
});

export const loadAutoSave = (tableId) => ({
  type: constant.LOAD_AUTO_SAVE,
  tableId
});

/**
 * 复制确认：把源表填写的数据按因子路径映射存入 pending（localStorage），
 * 下次打开同组其它表时由 loadScoreTable 回填。用户可核对后再自行提交。
 */
export const confirmCopy = (currentTableInfo, projectInfo) => {
  return (dispatch) => {
    const projectId = String(projectInfo.get("id"));
    const tableId = String(currentTableInfo.get("id"));
    const group = getGroup(projectId, tableId);
    if (group) {
      const groupId = groupIdOf(group);
      const valueMap = buildValueMap(currentTableInfo);
      setPending(projectId, groupId, {
        sourceTableId: tableId,
        valueMap,
        appliedTables: []
      });
      markPrompted(projectId, groupId);
    }
    dispatch({
      type: constant.COPY_CONFIRM
    });
  };
};

/**
 * 复制取消：仅关闭提示（是否已提示已在提交时标记，不会再次弹出）
 */
export const cancelCopy = () => {
  return (dispatch) => {
    dispatch({
      type: constant.COPY_CANCEL
    });
  };
};
